import React from 'react'
import PropTypes from 'prop-types'

const IconSuperManu = ({initials}) => {
  return (
    <svg
      width={64}
      height={64}
      enableBackground="new 0 0 100 100"
      version="1.1"
      viewBox="0 0 100 100"
    >
      <g transform="matrix(1.2059 0 0 1.1871 -8.9638 -24.52)" fill="#e6e6e6">
        <path
          d="m48.973 40.902c5.3124 0 9.6335-3.0416 9.6335-6.7801 0-3.7385-4.3222-6.7793-9.6335-6.7793-5.3113 0-9.6335 3.0416-9.6335 6.7793-0.0011 3.7385 4.321 6.7801 9.6335 6.7801zm0-11.562c3.7464 0 6.7944 2.1449 6.7944 4.7814 0 2.6364-3.0491 4.7822-6.7944 4.7822-3.7464 0-6.7944-2.1457-6.7944-4.7822 0-2.6364 3.0469-4.7814 6.7944-4.7814z"
          strokeWidth=".95265"
        />
        <path
          d="m71.598 49.938v-0.22536l-0.01589-0.14545c-0.88579-4.2363-6.1426-7.4306-12.226-7.4306h-20.767c-6.0835 0-11.339 3.195-12.225 7.4306v0.34204l-18.294 32.21 3.2502-1.0677c3.1968-1.0501 9.1781-2.3807 11.611-1.4848 0.76541 0.2821 1.4956 0.66011 2.2701 1.0613 1.7977 0.93182 3.8634 2.0035 6.8717 2.0035 1.4161-7.99e-4 3.0435-0.24055 4.9468-0.84152v11.743c0 2.1705 2.5086 3.9367 5.5941 3.9367 3.0832 0 5.5929-1.7661 5.5929-3.9367v-13.287h1.5342v13.287c0 2.1705 2.5086 3.9367 5.5918 3.9367 3.0844 0 5.5941-1.7661 5.5941-3.9367v-11.743c1.9033 0.60097 3.5295 0.84152 4.9456 0.84152 3.0071-7.99e-4 5.0751-1.0717 6.8728-2.0035 0.77336-0.40118 1.5036-0.77998 2.269-1.0613 2.4348-0.89746 8.415 0.43474 11.612 1.4848l3.2502 1.0677zm-7.1612 7.182h4.3233v10.535c0 0.83912-0.96982 1.5208-2.1611 1.5208-1.1913 0-2.1611-0.68248-2.1611-1.5208v-10.535zm-20.928-12.986h10.93v1.1484c0 2.121-2.4518 3.8464-5.4658 3.8464-3.0139 0-5.4658-1.7254-5.4658-3.8464v-1.1484zm-4.9195 0h2.0805v1.1484c0 3.2222 3.7248 5.8443 8.3048 5.8443 4.58 0 8.3048-2.6212 8.3048-5.8443v-1.1484h2.0793c4.6526 0 8.6773 2.4262 9.4018 5.6541v5.3336h-4.3233v-2.5677c0-0.99655-1.3071-1.0069-2.3587-1.0149-0.6121-0.0048-1.4933-0.0088-2.5654-0.01279l-1.4263-0.0048v11.092h-18.228v-11.091l-1.4263 0.0048c-1.072 0.0032-1.9521 8e-3 -2.5654 0.01279-1.0505 8e-3 -2.3587 0.01758-2.3587 1.0149v2.5677h-4.321v-5.3336c0.72566-3.2294 4.7492-5.6549 9.4018-5.6549zm6.7785 24.285v22.265h-5.5089v-26.072h18.228v26.073h-5.5078v-22.265h-7.2112zm-16.179-11.299h4.321v10.535c0 0.83912-0.96982 1.5208-2.16 1.5208s-2.16-0.68248-2.16-1.5208v-10.535zm-2.3042 21.899c-0.8256-0.42755-1.6796-0.87028-2.6358-1.2227-0.0477-0.01678-0.0988-0.02957-0.1465-0.04635l1.8374-4.3099-2.7198-0.5746-1.8874 4.4273c-2.6721-0.10389-5.7803 0.48669-8.0618 1.0517l13.088-23.045-0.010131 12.353c0 1.9404 2.2429 3.5187 4.999 3.5187s4.999-1.5791 4.999-3.5187v-14.12c0.19419-7.99e-4 0.41677-0.0024 0.67229-0.0032v26.029c-5.2136 1.9971-7.4043 0.87428-10.134-0.54023zm15.73 16.452c-1.5183 0-2.755-0.86949-2.755-1.9388v-0.85031h5.5089v0.85031c0 1.0693-1.2356 1.9388-2.7539 1.9388zm5.5929-17.223v-7.831h1.5342v7.831zm7.1249 17.223c-1.5183 0-2.7528-0.86949-2.7528-1.9388v-0.85031h5.5078v0.85031c0 1.0693-1.2356 1.9388-2.755 1.9388zm21.173-18.173-2.5756-4.5169-2.6346 0.74482 2.4302 4.2619c-0.0091 0.0032-0.01931 0.0056-0.02725 0.0088-0.95733 0.35243-1.8102 0.79516-2.6358 1.2227-2.7278 1.4145-4.9161 2.5397-10.134 0.54023v-26.029c0.25552 7.99e-4 0.4781 0.0024 0.67229 0.0032v14.12c0 1.9404 2.244 3.5187 5.0001 3.5187 2.7562 0 5.0001-1.5791 5.0001-3.5187v-12.331l13.077 23.023c-2.3133-0.573-5.476-1.1732-8.1719-1.0477z"
          strokeWidth=".95265"
        />
        <text
          transform="scale(1.3388 .74695)"
          x="27.564325"
          y="79.358742"
          fontFamily="sans-serif"
          fontSize="16.162px"
          letterSpacing="0px"
          strokeWidth="1.5151"
          wordSpacing="0px"
          style={{
            fontFeatureSettings: 'normal',
            fontVariantCaps: 'normal',
            fontVariantLigatures: 'normal',
            fontVariantNumeric: 'normal',
            lineHeight: '1.25',
          }}
          xmlSpace="preserve"
        >
          <tspan
            x="27.564325"
            y="93.657936"
            fill="#e6e6e6"
            fontFamily="sans-serif"
            fontSize="16.162px"
            strokeWidth="1.5151"
            style={{
              fontFeatureSettings: 'normal',
              fontVariantCaps: 'normal',
              fontVariantLigatures: 'normal',
              fontVariantNumeric: 'normal',
            }}
          />
        </text>
        <text
          transform="scale(1.0822 .92403)"
          x="38.319328"
          y="62.245037"
          fontFamily="sans-serif"
          fontSize="29.142px"
          letterSpacing="0px"
          strokeWidth=".72854"
          wordSpacing="0px"
          style={{lineHeight: '1.25'}}
          xmlSpace="preserve"
        >
          <tspan
            x="38.319328"
            y="62.245037"
            fill="#e6e6e6"
            fontFamily="sans-serif"
            fontSize="7.7712px"
            fontWeight="bold"
            strokeWidth=".72854"
            style={{
              fontFeatureSettings: 'normal',
              fontVariantCaps: 'normal',
              fontVariantLigatures: 'normal',
              fontVariantNumeric: 'normal',
            }}
          >
            {initials}
          </tspan>
        </text>
      </g>
    </svg>
  )
}

IconSuperManu.propTypes = {
  initials: PropTypes.string.isRequired,
}

export default IconSuperManu
